import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const dmsRoutes = [
	{
		key: "dms-admin",
		exact: true,
		path: `${APP_PREFIX_PATH}/dms/admin`,
		component: React.lazy(() => import("views/app-views/dms/pages/DMSAdmin")),
	},
	{
		key: "dms-space",
		exact: true,
		path: `${APP_PREFIX_PATH}/dms/space`,
		component: React.lazy(() => import("views/app-views/dms/pages/DMSSpace")),
	},
];
